var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseEnrolled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0667 6.33332L13 7.27332L8.64667 11.6667L6.33333 9.33332L7.26667 8.39332L8.64667 9.77999L12.0667 6.33332ZM4.66667 9.33332L4.95956 9.62622C5.58953 10.2562 5.14336 11.3333 4.25245 11.3333H0.999999C0.447714 11.3333 0 10.8856 0 10.3333V9.99999C0 8.52666 2.38667 7.33332 5.33333 7.33332L6.59333 7.40666L4.66667 9.33332ZM5.33333 0.666656C6.04058 0.666656 6.71885 0.947608 7.21895 1.4477C7.71905 1.9478 8 2.62608 8 3.33332C8 4.04057 7.71905 4.71884 7.21895 5.21894C6.71885 5.71904 6.04058 5.99999 5.33333 5.99999C4.62609 5.99999 3.94781 5.71904 3.44772 5.21894C2.94762 4.71884 2.66667 4.04057 2.66667 3.33332C2.66667 2.62608 2.94762 1.9478 3.44772 1.4477C3.94781 0.947608 4.62609 0.666656 5.33333 0.666656Z",
    fill: "#002C3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseEnrolled);
export default __webpack_public_path__ + "static/media/CourseEnrolled.08c63db5e7f715f7388503524278925f.svg";
export { ForwardRef as ReactComponent };